import { concatAll } from '~/utils/lib/core/prelude'

export const getSignaturesRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/signatures`
  ])

export const getSignaturesSepaFormRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/signatures/sepa/form`
  ])

export const getSignaturesSepaPayRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/signatures/sepa/pay`
  ])

export const getSignaturesSuccessRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {string} */ paymentId,
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/signatures?payment_id=${paymentId}&sepa=true`
  ])
